import { ReportTemplateVar } from '../models/ReportTemplate';

// Sostituisce {{VAR}} con il valore d'esempio della variabile (se presente).
// Gli id del BE sono nel formato "|VAR|", nei report v2 la variabile e' "{{VAR}}".
export function applyExampleValues(html: string, variables: ReportTemplateVar[]): string {
  let result = html;
  for (const variable of variables) {
    const id = (variable.id ?? '').replace(/\|/g, '');
    if (!id || !variable.exampleValue) {
      continue;
    }
    const example = variable.exampleValue
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    result = result.split(`{{${id}}}`).join(example);
  }
  return result;
}
